import { ProcessId } from './../../services/constants.service';
import { createAppState } from './app.model';
import { AppQuery } from './app.query';
import { SessionStorageType } from '../../services/tracking/session-storage';
import * as i0 from "@angular/core";
import * as i1 from "./app.store";
export class AppService {
    constructor(appStore) {
        this.appStore = appStore;
        this.appQuery = new AppQuery(this.appStore);
        const storage = sessionStorage.getItem(SessionStorageType.APP);
        if (storage === undefined || storage === null) {
            const app = createAppState({});
            this.app = app;
        }
        else {
            this.app = JSON.parse(storage);
        }
    }
    set app(app) {
        this.appStore.set([app]);
        sessionStorage.setItem(SessionStorageType.APP, JSON.stringify(app));
    }
    get app() {
        if (this.appQuery.getCount() === 1) {
            const app = this.appQuery.getAll()[0];
            return createAppState({
                processId: ProcessId.LLC,
                accessToken: app.accessToken,
                sessionId: app.sessionId,
                customerId: app.customerId,
                loginEmail: app.loginEmail,
                questionnaireId: app.questionnaireId,
                orderId: app.orderId,
                cartId: app.cartId,
                processingOrderId: app.processingOrderId,
                isQuestionnaireComplete: app.isQuestionnaireComplete,
                currentView: app.currentView,
                amount: app.amount,
                paymentProfileId: app.paymentProfileId,
                paymentGateway: app.paymentGateway,
                getCartBalanceByCartIdResponse: app.getCartBalanceByCartIdResponse,
                gSuiteCrossSellOrderResponse: app.gSuiteCrossSellOrderResponse,
                getOrderContactResponse: app.getOrderContactResponse,
                gSuiteCrossSellPaymentResponse: app.gSuiteCrossSellPaymentResponse,
                updateProcessingOrderResponse: app.updateProcessingOrderResponse,
                expressOrderProcessType: app.expressOrderProcessType,
                tmsCrossSellOrderResponse: app.tmsCrossSellOrderResponse,
                lwtCrossSellOrderResponse: app.lwtCrossSellOrderResponse,
                tmsCrossSellPaymentResponse: app.tmsCrossSellPaymentResponse,
                lwtCrossSellPaymentResponse: app.lwtCrossSellPaymentResponse,
                createProcessingOrderQueue: app.createProcessingOrderQueue,
                isGuestConvertedOnCheckout: app.isGuestConvertedOnCheckout,
                firstName: app.firstName,
                lastName: app.lastName,
                cart: app.cart,
                payment: app.payment
            });
        }
        else {
            const ls = JSON.parse(sessionStorage.getItem(SessionStorageType.APP));
            if (ls === undefined) {
                return null;
            }
            else {
                return ls;
            }
        }
    }
    set state(app) {
        this.appStore.set([app]);
        sessionStorage.setItem(SessionStorageType.APP, JSON.stringify(app));
    }
    get state() {
        if (this.appQuery.getCount() === 1) {
            const app = this.appQuery.getAll()[0];
            return createAppState({
                processId: ProcessId.LLC,
                accessToken: app.accessToken,
                sessionId: app.sessionId,
                customerId: app.customerId,
                loginEmail: app.loginEmail,
                questionnaireId: 27,
                orderId: app.orderId,
                cartId: app.cartId,
                processingOrderId: app.processingOrderId,
                isQuestionnaireComplete: app.isQuestionnaireComplete,
                currentView: app.currentView,
                amount: app.amount,
                paymentProfileId: app.paymentProfileId,
                paymentGateway: app.paymentGateway,
                getCartBalanceByCartIdResponse: app.getCartBalanceByCartIdResponse,
                gSuiteCrossSellOrderResponse: app.gSuiteCrossSellOrderResponse,
                getOrderContactResponse: app.getOrderContactResponse,
                gSuiteCrossSellPaymentResponse: app.gSuiteCrossSellPaymentResponse,
                expressOrderProcessType: app.expressOrderProcessType,
                updateProcessingOrderResponse: app.updateProcessingOrderResponse,
                tmsCrossSellOrderResponse: app.tmsCrossSellOrderResponse,
                lwtCrossSellOrderResponse: app.lwtCrossSellOrderResponse,
                tmsCrossSellPaymentResponse: app.tmsCrossSellPaymentResponse,
                lwtCrossSellPaymentResponse: app.lwtCrossSellPaymentResponse,
                createProcessingOrderQueue: app.createProcessingOrderQueue,
                isGuestConvertedOnCheckout: app.isGuestConvertedOnCheckout,
                firstName: app.firstName,
                lastName: app.lastName,
                cart: app.cart,
                payment: app.payment
            });
        }
        else {
            const ls = JSON.parse(sessionStorage.getItem(SessionStorageType.APP));
            if (ls === undefined) {
                return null;
            }
            else {
                return ls;
            }
        }
    }
    set accessToken(accessToken) {
        const state = this.state;
        state.accessToken = accessToken;
        this.state = state;
    }
    get accessToken() {
        return this.state.accessToken;
    }
    set sessionId(sessionId) {
        const state = this.state;
        state.sessionId = sessionId;
        this.state = state;
    }
    get sessionId() {
        return this.state.sessionId;
    }
    set customerId(customerId) {
        const state = this.state;
        state.customerId = customerId;
        this.state = state;
    }
    get customerId() {
        return this.state.customerId;
    }
    set loginEmail(loginEmail) {
        const state = this.state;
        state.loginEmail = loginEmail;
        this.state = state;
    }
    get loginEmail() {
        return this.state.loginEmail;
    }
    set cartId(cartId) {
        const state = this.state;
        state.cartId = cartId;
        this.state = state;
    }
    get cartId() {
        return this.state.cartId;
    }
    set orderId(orderId) {
        const state = this.state;
        state.orderId = orderId;
        this.state = state;
    }
    get orderId() {
        return this.state.orderId;
    }
    set processingOrderId(processingOrderId) {
        const state = this.state;
        state.processingOrderId = processingOrderId;
        this.state = state;
    }
    get processingOrderId() {
        return this.state.processingOrderId;
    }
    set questionnaireId(questionnaireId) {
        const state = this.state;
        state.questionnaireId = questionnaireId;
        this.state = state;
    }
    get questionnaireId() {
        return this.state.questionnaireId;
    }
    set processId(processId) {
        const state = this.state;
        state.processId = processId;
        this.state = state;
    }
    get processId() {
        return this.state.processId;
    }
    set currentView(currentView) {
        const state = this.state;
        state.currentView = currentView;
        this.state = state;
    }
    get currentView() {
        return this.state.currentView;
    }
    set amount(amount) {
        const state = this.state;
        state.amount = amount;
        this.state = state;
    }
    get amount() {
        return this.state.amount;
    }
    set paymentProfileId(paymentProfileId) {
        const state = this.state;
        state.paymentProfileId = paymentProfileId;
        this.state = state;
    }
    get paymentProfileId() {
        return this.state.paymentProfileId;
    }
    set paymentGateway(paymentGateway) {
        const state = this.state;
        state.paymentGateway = paymentGateway;
        this.state = state;
    }
    get paymentGateway() {
        return this.state.paymentGateway;
    }
    set getCartBalanceByCartIdResponse(getCartBalanceByCartIdResponse) {
        const state = this.state;
        state.getCartBalanceByCartIdResponse = getCartBalanceByCartIdResponse;
        this.state = state;
    }
    get getCartBalanceByCartIdResponse() {
        return this.state.getCartBalanceByCartIdResponse;
    }
    set gSuiteCrossSellOrderResponse(gSuiteCrossSellOrderResponse) {
        const state = this.state;
        state.gSuiteCrossSellOrderResponse = gSuiteCrossSellOrderResponse;
        this.state = state;
    }
    get gSuiteCrossSellOrderResponse() {
        return this.state.gSuiteCrossSellOrderResponse;
    }
    set getOrderContactResponse(getOrderContactResponse) {
        const state = this.state;
        state.getOrderContactResponse = getOrderContactResponse;
        this.state = state;
    }
    get getOrderContactResponse() {
        return this.state.getOrderContactResponse;
    }
    set gSuiteCrossSellPaymentResponse(gSuiteCrossSellPaymentResponse) {
        const state = this.state;
        state.gSuiteCrossSellPaymentResponse = gSuiteCrossSellPaymentResponse;
        this.state = state;
    }
    get gSuiteCrossSellPaymentResponse() {
        return this.state.gSuiteCrossSellPaymentResponse;
    }
    set updateProcessingOrderResponse(updateProcessingOrderResponse) {
        const state = this.state;
        state.updateProcessingOrderResponse = updateProcessingOrderResponse;
        this.state = state;
    }
    get updateProcessingOrderResponse() {
        return this.state.updateProcessingOrderResponse;
    }
    set expressOrderProcessType(expressOrderProcessType) {
        const state = this.state;
        state.expressOrderProcessType = expressOrderProcessType;
        this.state = state;
    }
    get expressOrderProcessType() {
        return this.state.expressOrderProcessType;
    }
    set tmsCrossSellOrderResponse(tmsCrossSellOrderResponse) {
        const state = this.state;
        state.tmsCrossSellOrderResponse = tmsCrossSellOrderResponse;
        this.state = state;
    }
    get tmsCrossSellOrderResponse() {
        return this.state.tmsCrossSellOrderResponse;
    }
    set lwtCrossSellOrderResponse(lwtCrossSellOrderResponse) {
        const state = this.state;
        state.lwtCrossSellOrderResponse = lwtCrossSellOrderResponse;
        this.state = state;
    }
    get lwtCrossSellOrderResponse() {
        return this.state.lwtCrossSellOrderResponse;
    }
    set tmsCrossSellPaymentResponse(tmsCrossSellPaymentResponse) {
        const state = this.state;
        state.tmsCrossSellPaymentResponse = tmsCrossSellPaymentResponse;
        this.state = state;
    }
    get tmsCrossSellPaymentResponse() {
        return this.state.tmsCrossSellPaymentResponse;
    }
    set lwtCrossSellPaymentResponse(lwtCrossSellPaymentResponse) {
        const state = this.state;
        state.lwtCrossSellPaymentResponse = lwtCrossSellPaymentResponse;
        this.state = state;
    }
    get lwtCrossSellPaymentResponse() {
        return this.state.lwtCrossSellPaymentResponse;
    }
    set createProcessingOrderQueue(createProcessingOrderQueue) {
        const state = this.state;
        state.createProcessingOrderQueue = createProcessingOrderQueue;
        this.state = state;
    }
    get createProcessingOrderQueue() {
        return this.state.createProcessingOrderQueue;
    }
    set isGuestConvertedOnCheckout(isGuestConvertedOnCheckout) {
        const state = this.state;
        state.isGuestConvertedOnCheckout = isGuestConvertedOnCheckout;
        this.state = state;
    }
    get isGuestConvertedOnCheckout() {
        return this.state.isGuestConvertedOnCheckout;
    }
    set firstName(firstName) {
        const state = this.state;
        state.firstName = firstName;
        this.state = state;
    }
    get firstName() {
        return this.state.firstName;
    }
    set lastName(lastName) {
        const state = this.state;
        state.lastName = lastName;
        this.state = state;
    }
    get lastName() {
        return this.state.lastName;
    }
    set cart(cart) {
        const state = this.state;
        state.cart = cart;
        this.state = state;
    }
    get cart() {
        return this.state.cart;
    }
    set payment(payment) {
        const state = this.state;
        state.payment = payment;
        this.state = state;
    }
    get payment() {
        return this.state.payment;
    }
}
AppService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppService_Factory() { return new AppService(i0.ɵɵinject(i1.AppStore)); }, token: AppService, providedIn: "root" });
